import reduxActions from './actions'
import reduxTypes from './types'

export const Redux = {
  Actions: reduxActions,
  Types: reduxTypes,
}
